import React from 'react';
import { Link } from 'react-router-dom';

export default function PageHero({ eyebrow, title, sub, image, accent = 'green' }) {
  const accentColor = accent === 'orange' ? '#FF7A00' : '#1F8B4C';
  return (
    <section
      className="relative pt-32 pb-20 overflow-hidden"
      style={{
        background:
          accent === 'orange'
            ? 'linear-gradient(135deg, #FFF7EE 0%, #FFE9CF 50%, #ffffff 100%)'
            : 'linear-gradient(135deg, #E8F5EE 0%, #CDEBD8 50%, #ffffff 100%)',
      }}
    >
      <div
        className="blob"
        style={{ background: accentColor, width: 380, height: 380, top: -100, right: -100 }}
      />
      <div className="container-x relative z-10 grid lg:grid-cols-2 gap-10 items-center">
        <div className="fade-up">
          <nav className="text-xs font-semibold text-[color:var(--ink-soft)] mb-4">
            <Link to="/" className="hover:text-[color:var(--brand-green)]">Home</Link>
            <span className="mx-2">/</span>
            <span style={{ color: accentColor }}>{title}</span>
          </nav>
          <div className="eyebrow" style={{ color: accentColor }}>{eyebrow}</div>
          <h1 className="font-black text-[color:var(--ink)] leading-[1.1] tracking-tight text-[42px] sm:text-[52px] mt-3">
            {title}
          </h1>
          <p className="mt-5 text-[color:var(--ink-soft)] text-lg leading-relaxed max-w-xl">
            {sub}
          </p>
        </div>
        {image && (
          <div className="relative fade-up" style={{ animationDelay: '0.15s' }}>
            <img
              src={image}
              alt={title}
              className="rounded-3xl w-full h-[380px] object-cover shadow-2xl border-4 border-white"
            />
          </div>
        )}
      </div>
    </section>
  );
}
